import React from 'react';

import { Text } from './Text.styles';

type TextElementProps = React.HTMLAttributes<HTMLSpanElement> & {
  strong?: boolean;
  serif?: boolean;
};

/**
 * Zola-UI 3.0 compliant text element.
 *
 * - Remove all margin / padding
 * - Sets the font to FONT.FAMILY.SERIF if the `serif` flag is present
 * - Returns a <strong> element and sets the font weight to FONT.WEIGHT.SEMI_BOLD if the `strong` flag is present
 *
 * The minimal styling allows it to be used in any Heading, Paragraph or anywhere else.
 *
 */
export const TextElement = ({ strong, serif, ...rest }: TextElementProps): JSX.Element => {
  const component = strong ? 'strong' : 'span';
  return <Text as={component} strong={strong} serif={serif} {...rest} />;
};

export const Strong = (props: React.HTMLAttributes<HTMLSpanElement>): JSX.Element => (
  <TextElement strong {...props} />
);
export const Serif = (props: React.HTMLAttributes<HTMLSpanElement>): JSX.Element => (
  <TextElement serif {...props} />
);
export const Accent = (props: React.HTMLAttributes<HTMLSpanElement>): JSX.Element => (
  <TextElement strong serif {...props} />
);

export default {
  Strong,
  Serif,
  Accent,
};
